/* @flow */
import EventEmitter from "events";
import uuid from "uuid";

const cache = {};

class FormManager extends EventEmitter {
    addListener = (event: string, callback: any => any): any => {
        this.on(event, callback);
    };
    registerControl = (formId: string, control: Object): boolean => {
        cache[formId] = cache[formId] || { controls: new Set(), isValid: false };
        cache[formId].controls.add(control);
        return cache[formId].controls.has(control);
    };
    removeControl = (id: string, control: Object): boolean => Boolean(cache[id]) && cache[id].controls.has(control) && cache[id].controls.delete(control);
    removeForm = (id: string): boolean => {
        const hadForm = Boolean(cache[id]);
        const removed = Reflect.deleteProperty(cache, id) && hadForm;
        if (removed) {
            this.emit("FORM_REMOVED", id);
        }
        return removed;
    };
    addForm = (id: ?string): boolean => {
        const _id = id || uuid();
        const hasId = Boolean(cache[_id]);
        if (!hasId) {
            cache[_id] = { controls: new Set(), isValid: false };
            this.emit("FORM_ADDED", _id);
        }
        return !hasId;
    };
    validate = (id: string): boolean => {
        const newValue = Array.from(cache[id].controls).reduce((valid, control) => control.validate() && valid, true);
        if (newValue !== cache[id].isValid) {
            cache[id].isValid = newValue;
            this.emit("FORM_VALIDATION", id, cache[id].isValid);
        }
        return cache[id].isValid;
    };
    eventConstants = Object.freeze({
        FORM_VALIDATION: "FORM_VALIDATION",
        FORM_ADDED: "FORM_ADDED",
        FORM_REMOVED: "FORM_REMOVED"
    });
}


export const formManager = new FormManager();


